import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { getRolesSelector } from '../../reducers/roles';
import { getNestMapLockingsSelector } from '../../reducers/lockings';
import { rightsSelector } from '../../reducers/rights';
import {
	getExtraColsNumberSelector,
	getExtraRowsNumberSelector
} from '../../reducers/app';
import { getCollapsedGroups } from '../../reducers/app/collapsedGroups';

import { addRightsRequest, deleteRightsRequest } from './rightsActions';

import RightsTableData from './RightsTableData';
import Icon from '../../common/components/Icon';

class RightsTableContainer extends Component {
	constructor(props) {
		super(props);
	}

	componentDidUpdate() {
		// const elems = document.getElementsByClassName("js-role-2759");
		// console.log("elems", elems)
		// for (let el of elems) {
		// 			el.classList.add("glow");
		// }
	}

	render() {
		return (
			<div>
				{this.props.lockings.map(locking => this.renderRow(locking))}
				{this.generateEmptyRows()}
			</div>
		);
	}

	renderRow(locking) {
		if (locking && locking.children) {
			return this.renderGroupRows(locking);
		}
		if (locking) {
			return this.renderLockingRow(locking);
		}
	}

	renderLockingRow(locking) {
		const emptyColsNumer = this.props.extraColsNumber;
		return (
			<div className="rights-table__row u-flex" key={locking.locking_id}>
				{this.renderRolesCols(locking)}
				{this.generateEmptyCols(emptyColsNumer)}
			</div>
		);
	}

	renderRolesCols(locking) {
		return this.props.roles.map(role => {
			const hasRight = this.props.rights[role.role_id][
				locking.locking_id
			];

			return (
				<RightsTableData
					key={role.role_id}
					roleId={role.role_id}
					onClick={this.props.toggleRight.bind(
						null,
						role,
						locking,
						hasRight
					)}
				>

					{this.renderRight(hasRight)}
				</RightsTableData>
			);
		});
	}

	renderGroupRows(locking) {
		const rows = [];
		rows.push(this.renderEmptyRow(locking.locking_id));

		const isCollapsed = this.props.collapsedGroups[locking.locking_id];
		if (!isCollapsed) {
			locking.children.forEach(locking =>
				rows.push(this.renderLockingRow(locking))
			);
		}
		return rows;
	}

	renderEmptyRow(key) {
		const emptyColsNumer =
			this.props.extraColsNumber + this.props.roles.length;
		return (
			<div className="rights-table__row u-flex" key={key}>
				{this.generateEmptyCols(emptyColsNumer)}
			</div>
		);
	}

	generateEmptyRows() {
		const rows = [];
		const emptyRowsNumber = this.props.extraRowsNumber;
		for (let i = 0; i < emptyRowsNumber; i++) {
			rows.push(this.renderEmptyRow(i));
		}
		return rows;
	}

	generateEmptyCols(colsNumber) {
		const cols = [];
		for (let i = 0; i < colsNumber; i++) {
			cols.push(<RightsTableData lockingId={1} roleId={1} key={i} />);
		}
		return cols;
	}

	renderRight(hasRight) {
		if (hasRight) return <Icon icon="check-validate" />;
		else return <Icon icon="lock" />;
	}
}

function mapStateToProps(state) {
	return {
		roles: getRolesSelector(state),
		lockings: getNestMapLockingsSelector(state),
		rights: rightsSelector(state),
		extraColsNumber: getExtraColsNumberSelector(state),
		extraRowsNumber: getExtraRowsNumberSelector(state),
		collapsedGroups: getCollapsedGroups(state)
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		toggleRight: (role, locking, hasRight) => {
			const toggle = hasRight ? deleteRightsRequest : addRightsRequest;

			dispatch(toggle(projectId, [role], [locking]));
		}
	};
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(RightsTableContainer)
);



// WEBPACK FOOTER //
// ./src/js/plan/rights/RightsTableContainer.js